module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Contents"), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/acknowledgments#_idTextAnchor001"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/abbreviations#_idTextAnchor002"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/bibletransl#_idTextAnchor003"
    }
  }, [_vm._v("Bible Translations")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/commentaryguide#_idTextAnchor004"
    }
  }, [_vm._v("A Guide to Using This Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/genintro#_idTextAnchor005"
    }
  }, [_vm._v("General Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction#_idTextAnchor006"
    }
  }, [_vm._v("Introduction to 1–2 Samuel, 1–2 Kings, 1–2 Chronicles")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/1samuel#_idTextAnchor072"
    }
  }, [_vm._v("Commentary on 1 Samuel")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/2samuel#_idTextAnchor3462",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary on 2 Samuel")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/1kings#_idTextAnchor4184",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary on 1 Kings")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/2kings#_idTextAnchor4964",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary on 2 Kings")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/1chronicles#_idTextAnchor5755",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary on 1 Chronicles")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/2chronicles#_idTextAnchor6152",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Commentary on 2 Chronicles")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/mapandtimeline#page674",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Map of Europe at the Time of the Reformation")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/mapandtimeline#page675",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Timeline of the Reformation")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/figuresandworks#_idTextAnchor6678",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biographical Sketches of Reformation-Era Figures and Works")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/sourcesbiosketch#_idTextAnchor6680",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources for Biographical Sketches")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/bibliography#_idTextAnchor6681",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/authorwritingsindex#_idTextAnchor6682",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author and Writings Index")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/subjectindex#_idTextAnchor6684",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Subject Index")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/scriptureindex#_idTextAnchor6686",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture Index")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/praise#_idTextAnchor6687",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for the Reformation Commentary on Scripture")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/advisers#_idTextAnchor6688",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reformation Commentary on Scripture Board of Advisers")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/serieseditors#_idTextAnchor6689",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Series Editors")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/volumeeditor#_idTextAnchor6690",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Volume Editor")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/RConS#_idTextAnchor6691",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reformation Commentary on Scripture")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/textbookselector#_idTextAnchor6692",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IVP Academic Textbook Selector")])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexii",
      "title": "xii"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "pagexiii",
      "title": "xiii"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 69
// module chunks = 0